import React from 'react'
import { Button, Col, Image, Row, Typography } from 'antd'
import LOGO from 'assets/images/icon_register_success.png'
import './index.css'

interface IProps {
  message: string
  confirmText?: string
  onClose: () => void
  logo?: string
  styles?: React.CSSProperties
  options?: any
  colSpan?: any
}

const ResponseDialog = ({ message, onClose, logo, styles, options, colSpan = 12, confirmText = 'Listo' }: IProps) => {
  return (

    <Row justify={'center'} align={'middle'} style={styles}>
      <Col span={colSpan} className='container-success'>
        <Image src={logo ?? LOGO} className='logo-success' preview={false} />
        <Typography className='description'>
          <span dangerouslySetInnerHTML={{ __html: message }} />
        </Typography>
        {options ? options : <Button className='next-button' onClick={onClose}>{confirmText}</Button>}
      </Col>
    </Row >
  )
}

export default ResponseDialog
